var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'row'+' '+ _vm.mainclass},[_c('div',{class:'col-lg-6 col-md-6 wow fadeIn'+' '+ _vm.topclass},[_c('div',{class:'text-left iq-title-box'+' '+_vm.subclass},[_c('h2',{class:'iq-title text-uppercase' +' '+ _vm.titleclass},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("underline")],2)]),_vm._t("rightside")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }